// extracted by mini-css-extract-plugin
module.exports = {"messageText":"formMessage_messageText__1Vf0G","messageSuccess":"formMessage_messageSuccess__2zMUO","messageFail":"formMessage_messageFail__2z923"};